import {OverlayRef} from "@angular/cdk/overlay";
import {merge, take} from "rxjs";
import {filter} from "rxjs/operators";

export function beforeOverlayClosed(overlayRef: OverlayRef) {
  return merge(
    overlayRef.backdropClick(),
    overlayRef.keydownEvents().pipe(filter(e => e.key === 'Escape')),
    overlayRef.detachments()
  ).pipe(take(1));
}
